import gabrieli from '../images/gabrielli.jpeg';
import peri from '../images/peri.jpg';
import monteverdi from '../images/claudiomonteverdi.jpg';
import frescobaldi from '../images/girolamofrescobaldi.jpeg';
import schutz from '../images/heinrichschutz.jpg';
import lully from '../images/jeanbaptistelully.jpg';
import carissimi from '../images/giacomocarissimi.jpeg';
import biber from '../images/heinrichbiber.jpg';
import buxtehude from '../images/dieterichbuxtehude.png';
import purcell from '../images/henrypurcell.jpeg';
import corelli from '../images/arcangelocorelli.jpg';
import vivaldi from '../images/antoniovivaldi.jpg';
import couperin from '../images/francoiscouperin.jpeg';
import rameau from '../images/jeanphilipperameau.jpg';
import telemann from '../images/georgphilipptelemann.jpg';
import handel from '../images/georgfriedrichhandel.jpg';
import bach from '../images/johannsebastianbach.jpg';
import d_scarlatti from '../images/domenicoscarlatti.jpg';
import pergolesi from '../images/giovannibattistapergolesi.jpg';
import cpe_bach from '../images/carlphilippemanuelbach.jpg';
import stamitz from '../images/johannstamitz.jpeg';
import jc_bach from '../images/johannchristianbach.jpg';
import dittersdorf from '../images/carldittersvondittersdorf.jpg';
import leopold_mozart from '../images/leopoldmozart.jpg';
import haydn from '../images/josephhaydn.jpg';
import boccherini from '../images/luigiboccherini.jpg';
import clementi from '../images/muzioclementi.jpeg';
import mozart from '../images/wolfgangamadeusmozart.jpg';
import beethoven from '../images/ludwigvanbeethoven.jpg';
import schubert from '../images/franzschubert.jpg';
import weber from '../images/carlmariavonweber.jpg';
import mendelssohn from '../images/felixmendelssohn.jpg';
import schumann from '../images/robertschumann.jpeg';
import chopin from '../images/fredericchopin.jpeg';
import liszt from '../images/franzliszt.webp';
import berlioz from '../images/hectorberlioz.jpeg';
import wagner from '../images/richardwagner.jpg';
import verdi from '../images/giuseppeverdi.jpg';
import brahms from '../images/johannesbrahms.jpg';
import bruckner from '../images/antonbruckner.jpg';
import saint_saens from '../images/camillesaintsaens.jpg';
import bizet from '../images/georgesbizet.jpg';
import smetana from '../images/bedrichsmetana.jpg';
import tchaikovsky from '../images/pyotrilyichtchaikovsky.jpg';
import dvorak from '../images/antonindvorak.webp';
import scriabin from '../images/alexanderscriabin.jpg';
import rachmaninoff from '../images/sergeirachmaninoff.jpg';
import schoenberg from '../images/arnoldschoenberg.jpg';
import berg from '../images/albanberg.avif';
import webern from '../images/antonwebern.jpg';
import stravinsky from '../images/igorstravinsky.jpg';
import bartok from '../images/belabartok.jpg';
import prokofiev from '../images/sergeiprokofiev.jpg';
import shostakovich from '../images/dmitrishostakovich.jpg';
import britten from '../images/benjaminbritten.jpg';
import messiaen from '../images/oliviermessiaen.jpg';
import cage from '../images/johncage.jpg';
import boulez from '../images/pierreboulez.jpg';
import mahler from '../images/gustavmahler.jpg';
import r_strauss from '../images/richardstrauss.jpg';
import puccini from '../images/giacomopuccini.jpg';
import debussy from '../images/claudedebussy.jpg';
import ravel from '../images/mauriceravel.jpeg';
import sibelius from '../images/jeansibelius.jpg';
import faure from '../images/gabriellfore.jpg';
import mussorgsky from '../images/mussorgsky.jpg';
import balakirev from '../images/balakirew.jpg';
import mascagni from '../images/mascagni.jpg';
import hummel from '../images/hummel.jpg';

export const composerImages = {
  gabrieli,
  peri,
  monteverdi,
  frescobaldi,
  schutz,
  lully,
  carissimi,
  biber,
  buxtehude,
  purcell,
  corelli,
  vivaldi,
  couperin,
  rameau,
  telemann,
  handel,
  bach,
  d_scarlatti,
  pergolesi,
  cpe_bach,
  stamitz,
  jc_bach,
  dittersdorf,
  leopold_mozart,
  haydn,
  boccherini,
  clementi,
  mozart,
  beethoven,
  schubert,
  weber,
  mendelssohn,
  schumann,
  chopin,
  liszt,
  berlioz,
  wagner,
  verdi,
  brahms,
  bruckner,
  saint_saens,
  bizet,
  smetana,
  tchaikovsky,
  dvorak,
  scriabin,
  rachmaninoff,
  schoenberg,
  berg,
  webern,
  stravinsky,
  bartok,
  prokofiev,
  shostakovich,
  britten,
  messiaen,
  cage,
  boulez,
  mahler,
  r_strauss,
  puccini,
  debussy,
  ravel,
  sibelius,
  faure,
  mussorgsky,
  balakirev,
  mascagni,
  hummel,
};
